import React, { useState } from "react";
import { OBJECT_TYPE_TICKET } from "../../constants/ticket";
import TicketCard from "../TicketCard";
import Pagination from "../Pagination";

const TicketPrintPages = ({
  tickets = [],
  ticketStyle = {},
  objectType = OBJECT_TYPE_TICKET,
}) => {
  const ticketHeightInches = 1.97;
  const verticalGapInches = 0.4;
  const pageHeightInches = 11;
  const paddingInches = 1;

  const ticketPlusGap = ticketHeightInches + verticalGapInches;
  const availableVerticalSpace = pageHeightInches - paddingInches;
  const ticketsPerPage = Math.floor(
    (availableVerticalSpace + verticalGapInches) / ticketPlusGap
  );

  const pages = [];
  for (let i = 0; i < tickets.length; i += ticketsPerPage) {
    pages.push(tickets.slice(i, i + ticketsPerPage));
  }

  const [currentPageIndex, setCurrentPageIndex] = useState(0);
  const currentPage = pages[currentPageIndex] || [];

  return (
    <div className="flex-column align-center">
      <div>Page {currentPageIndex + 1} of {pages.length}</div>
      <div className="margin-top-1em">
        <Pagination
          itemCount={tickets.length}
          maxItemsPerPage={ticketsPerPage}
          currentPageIndex={currentPageIndex}
          onSelectIndex={(index) => setCurrentPageIndex(index)}
        />
      </div>
      <div
        className="letter-sheet"
        style={{
          width: "8.5in",
          height: "11in",
          padding: "0.5in",
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          gap: `${verticalGapInches}in`,
          backgroundColor: "var(--white)",
        }}
      >
        {currentPage.map((ticket, index) => (
          <div
            key={ticket.id || index}
            style={{
              width: "5.63in",
              height: "1.97in",
              overflow: "hidden",
              breakInside: "avoid",
            }}
          >
            <TicketCard
              ticket={ticket}
              objectType={objectType}
              style={ticketStyle}
              disableScaling={true}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default TicketPrintPages;